module.exports = __webpack_public_path__ + "img/pcard2.ce2c2e24.png";